export default "__VITE_ASSET__B3nv2ZkA__"